// Category/tag results pages show a larger first page (it includes the promotion slot), then a
// smaller uniform page size for subsequent pages.
export const ARTICLE_RESULT_FIRST_PAGE_AMOUNT = 14;
export const ARTICLE_RESULT_REST_PAGES_AMOUNT = 18;

export const ARTICLE_SEARCH_RESULTS_PER_PAGE = 12;

// Shared between the client (ArticleSearchBox input maxLength, URL truncation) and the server
// (services/cmsService.ts query escaping) - kept out of cmsService.ts so client components can
// import it without pulling the server-only CMS API client into the browser bundle.
export const MAX_ARTICLE_SEARCH_TERM_LENGTH = 200;
